import useMutationApi from 'src/api/useMutationApi';

interface Body {
  aliases: string[] | null;
}

const useUpdateAccountAliases = (
  customerId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<Body, void>({
    endpoint: `accounts-receivable/customers/${customerId}/aliases`,
    method: 'POST',
    options: {
      onSuccess,
    },
    showSuccessToast: true,
  });
};

export default useUpdateAccountAliases;
